<template>
    <div>
        <b-modal
            :id="popupId"
            ref="modal"
            :title="title"
            :size="size"
            hide-footer
            modal-class="hide-footer"
            :hide-header-close="loading"
            no-close-on-backdrop
            no-close-on-esc
        >
            <div
                class="export-form-section"
                style="padding: 10px"
                v-html="content"
            ></div>

            <b-form
                @submit.stop.prevent="onDoneWrapper"
                @reset.stop.prevent="onHiddenWrapper"
            >
                <div class="col-md-12 action-buttons">
                    <base-button
                        :class="loading ? 'disabled' : ''"
                        :btn-label="okMessage"
                        btn-type="submit"
                        btn-variant="primary"
                    ></base-button>
                    <base-button
                        v-if="showCancel"
                        :disabled="loading"
                        :btn-label="cancelMessage"
                        btn-type="reset"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

// import excelIcon from '@/components/icons/ExcelIcon.vue'
// import pdfIcon from '@/components/icons/PdfIcon.vue'
import _ from 'lodash'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        // excelIcon,
        // pdfIcon,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        popupId: {
            type: String,
            default: 'custom-popup',
        },
        size: {
            type: String,
            default: 'md',
        },
        title: {
            type: String,
            required: true,
        },
        content: {
            type: String,
            required: true,
        },
        okMessage: {
            type: String,
            default: 'OK',
        },
        cancelMessage: {
            type: String,
            default: 'Cancel',
        },
        showCancel: {
            type: Boolean,
            default: false,
        },
        onDone: {
            type: Function,
            default: () => {},
        },
        onHidden: {
            type: Function,
            default: () => {},
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    },

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'hidePopup', 'dataSegmentId', 'hasScopes']),
    },
    watch: {},
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onDoneWrapper() {
            this.onDone()
            this.$refs.modal.hide()
        },
        onHiddenWrapper() {
            this.onHidden()
            this.$refs.modal.hide()
        },
    },
}
</script>
